import React, {useState} from 'react';
import Popover from '@material-ui/core/Popover';
import useNetworkStatus from 'app/main/components/UseNetworkStatus';
import {makeStyles} from '@material-ui/core/styles';
import DataSyncDialog from 'app/layouts/shared-components/DataSyncDialog';

const useStyles = makeStyles({
	avatarName: {
		color: 'white',
		background: '#7b7b7b'
	}
});

const OnlineIndicator = () => {
	const isOnline = useNetworkStatus();
	const [anchorEl, setAnchorEl] = useState(null);
	const classes = useStyles();

	const handleClick = event => {
		setAnchorEl(event.currentTarget); // store the clicked element as anchor
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<>
			<div onClick={handleClick} className="cursor-pointer">
				{isOnline ? (
					<div className="flex items-center space-x-4">
						<span className="relative flex h-10 w-10">
							<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
							<span className="relative inline-flex rounded-full h-10 w-10 bg-green-500"></span>
						</span>
						<span className="text-green-500 text-sm font-medium">Online</span>
					</div>
				) : (
					<div className="flex items-center space-x-4">
						<span className="relative flex h-10 w-10">
							<span className="relative inline-flex rounded-full h-10 w-10 bg-yellow-500"></span>
						</span>
						<span className="text-yellow-500 text-sm font-medium">Offline</span>
					</div>
				)}
			</div>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				classes={{
					paper: 'py-8'
				}}
			>
				<div className="w-[320px] sm:w-[350px] p-10 max-h-[600px]">
					<DataSyncDialog />
				</div>
			</Popover>
		</>
	);
};

export default OnlineIndicator;
